import { ResourceItem } from 'sos-common/js/commonTypes/resourceItem';
import { EducationLocation } from '../../models/ansokan.model';
import { SpecialistbevisTyp } from '../AnsokanForms/Specialistbevis/SpecialistbevisAnsokanForm.types';
import { Register } from 'sos-common/js/commonTypes/Registers.types';

export interface IStepTwoSubmitButtonProps {
  validationBaseEndpoint: string;
  buttonText: string;
  label: string;
  conditionsText: string;
  isInEditMode: boolean;
  postLink: string;
  pollLink: string;
  swishPostLink: string;
  ansokanId: string;
  heading: string;
  myPageUrl: string;
  masterCardText?: string;
  errorHeader?: string;
  errorBody?: string;
  attentionBoxText?: string;
  stepOneLink: string;
  transactionId?: string;
  swishTranslations?: ResourceItem[];
  ansokanType: AnsokanType;
  educationLocation: EducationLocation;
  specialistBevisTyp?: SpecialistbevisTyp;
  paidAssessmentFeeEarlier?: boolean;
  paymentDate?: string;
  completedSupplementaryEducation?: boolean;
  yrke?: string;
}

export interface IStepTwoSubmitButtonState {
  acceptConditionsChecked: boolean;
  isHealthcheckDialogOpen: boolean;
  isValidationErrorDialogOpen: boolean;
  isSwishPaymentDialogOpen: boolean;
  preSwishRedirect: boolean;
  transactionId?: string;
  showSpinner: boolean;
}

export interface RadioField {
  label: string | JSX.Element;
  value: string;
  defaultChecked?: boolean;
}

export enum AnsokanType {
  Legitimation = 0,
  SkyddadYrkestitel = 1,
  Specialistbevis = 2,
  Intyg = 3,
  SpecialistbevisSverige = 4,
}

export const Kort: string = 'Kortbetalning';
export const Swish: string = 'Swish';
export const SwishM: string = 'SwishM';
